export const AI_BANNER_KEY = '__inscope_hide_workbook_ai_banner';
export const firstColWidth = 480;
